import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';

import { BankDetailsCardSkeletonProps } from './BankDetailsCardSkeleton.types';

const BankDetailsCardSkeleton: React.FC<BankDetailsCardSkeletonProps> = ({ className }) => {
  return (
    <Card className={`relative flex flex-column p4 ${className}`}>
      <div className="flex flex-row">
        <Skeleton variant="circle" height={36} width={36} />
        <div className="flex flex-column ml4">
          <BaseSkeleton className="mb2" width={90}/>
          <BaseSkeleton className="mb1" width={120} />
          <BaseSkeleton className="mb1" width={100}/>
          <BaseSkeleton className="mb1"/>
          <BaseSkeleton className="mb1" width={70} />
          <BaseSkeleton className="mb1" />
        </div>
      </div>
    </Card>
  );
};

export default BankDetailsCardSkeleton;
export { BankDetailsCardSkeletonProps };
